import * as logger from '@mamdev/navigator.frontend-logger'
import { BrandType } from './brand'
import { StageType } from './stage'
import { AuthCase } from './auth-case'

export type AuthModeType =
  'standalone'
  | 'navigator'
  | 'lightmailer-bs'
  | 'lightmailer-bap'

export type OauthCredentials = {
  clientId: string
  clientSecret: string
}

export async function getOauthCredentials(brand: BrandType, stage: StageType, authCase: AuthCase, authMode: AuthModeType): Promise<OauthCredentials> {
  // lightmailer uses the same credentials for both auth cases
  const authCasePart = authMode.indexOf('lightmailer') === 0 ? '' : '-' + authCase

  let url: string
  if (brand.indexOf('gmx') === 0) {
    // AT uses NET config
    brand = 'gmx.net'
  }

  if (stage === 'dev') {
    url = 'config/dev.json'
  } else {
    url = `config/${brand.replace('.', '')}-${stage}${authCasePart}-${authMode}.json`
  }
  logger.debug('fetching config from', url)

  const response = await fetch(url)
  return await response.json() as OauthCredentials
}
